import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    // 

    createChannel = new Subject();
    detailChannel = new Subject();
    repository = new CreateRepository()
    employeeChannel = new Subject();
    rankChannel = new Subject();
    
    typeChannel = new Subject()
  
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchRank = async (query) => {
        try {
            this.rankChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRank(query).then((result) => {
                this.rankChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rankChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchType = async (query) => {
        try {
            this.typeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchType(query).then((result) => {
                this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.typeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    
}

export default CreateBloc